import { AdminClassroomLayout } from "@/pages/admin/AdminClassroomLayout";
import { AdminSchoolsPage } from "@/pages/admin/AdminSchoolsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/schools/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AdminClassroomLayout>
      <AdminSchoolsPage />
    </AdminClassroomLayout>
  );
}
